define(['backbone', 'models/Printer'], function(Backbone, PrinterModel) {
  return Backbone.Collection.extend({
    model: PrinterModel
  });
});
